import { render, staticRenderFns } from "./AdminPostGroup.vue?vue&type=template&id=4ea83f61"
import script from "./AdminPostGroup.vue?vue&type=script&lang=js"
export * from "./AdminPostGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports